import React from 'react';
import { 
    useNavigate, 
    useLocation, 
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    useTheme,
    Box,
    Drawer as MUIDrawer,
    List, 
    Divider,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
} from '@mui/material';
import {
    LightModeRounded,
    DarkModeRounded,
    LoginRounded,
    DashboardRounded,
    PersonAddRounded,
    SettingsRounded,
    AddLinkRounded,
    CallMissedOutgoingRounded,
    TagRounded,
} from '@mui/icons-material';
import { withPather } from 'react-pather';
import { PROJECT_NAME } from '../../config';
import { roleIcon } from '../../utils';
import { toggleTheme } from '../../slices/themeSlice';

const Drawer = ({ pather, open, toggleDrawer, user, logout }) => {

    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const icon = roleIcon();

    const list = (
        <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <List>
                <Box sx={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1}}>
                    <Box 
                        className="noselect"
                        sx={{ 
                            fontFamily: 'Emblema One', 
                            color: theme.palette.text.main, 
                            fontSize: 22,
                            cursor: 'pointer'
                        }}
                        onClick={() => navigate('/')}
                    >
                        <span className='h1-style'>{PROJECT_NAME}</span>
                    </Box>
                    <Box>
                        <IconButton onClick={() => dispatch(toggleTheme())} sx={{cursor: 'pointer'}}>
                            { 
                                theme.palette.mode === 'dark' ?
                                <LightModeRounded fontSize='large' /> :
                                <DarkModeRounded fontSize='large' />
                            }
                        </IconButton> 
                    </Box>
                </Box>
                {
                    user?.isLogined &&
                    <>
                        <Divider sx={{mb: 2}}/>
                        <Box sx={{
                            display: 'flex', width: '100%', 
                            height: '100%', justifyContent: 'center', 
                            alignItems: 'center', fontSize: '1.5rem',
                            mb: 2, gap: 1, 
                        }}>
                            <Box sx={{overflow: 'auto'}}>  
                                {user.username}
                            </Box>    
                            {
                                icon && 
                                <Box>
                                    { icon }
                                </Box>
                            }
                        </Box>
                    </>
                }
                <Divider sx={{mb: 2}}/>
                {
                    !user.isLogined && location.pathname !== pather.front.shorten &&
                    <DrawerListItem 
                        onClick={() => navigate(pather.front.shorten)}
                        text='Shorten'
                        icon={<AddLinkRounded/>}
                    />
                }
                {
                    !user?.isLogined && location.pathname !== pather.front.login && 
                    <DrawerListItem 
                        onClick={() => navigate(pather.front.login)}
                        text='Log in'
                        icon={<LoginRounded/>}
                    />
                }
                {
                    !user?.isLogined && location.pathname !== pather.front.signup && 
                    <DrawerListItem 
                        onClick={() => navigate(pather.front.signup)}
                        text='Sign up'
                        icon={<PersonAddRounded/>}
                    />
                }
                {
                    user?.isLogined &&
                    <>
                        <DrawerListItem 
                            onClick={() => navigate(pather.front.dashboard)}
                            text='Dashboard'
                            icon={<DashboardRounded/>}
                        />
                        <DrawerListItem 
                            onClick={() => navigate(pather.front.shorten)}
                            text='Shorten'
                            icon={<AddLinkRounded/>}
                        />
                        <DrawerListItem 
                            onClick={() => navigate(pather.front.redirects)}
                            text='Redirects'
                            icon={<CallMissedOutgoingRounded/>}
                        />
                        <DrawerListItem 
                            onClick={() => navigate(pather.front.tags)}
                            text='Tags'
                            icon={<TagRounded/>}
                        />
                        {/* <DrawerListItem 
                            onClick={() => {}}
                            text='Plan'
                            icon={<PaidRounded/>}
                        /> */}
                        <DrawerListItem 
                            onClick={() => navigate(pather.front.settings)}
                            text='Settings'
                            icon={<SettingsRounded/>}
                        />
                        <DrawerListItem 
                            onClick={logout}
                            text='Log out'
                            icon={<LoginRounded/>}
                        />
                    </>
                }
            </List>
        </Box>
    );

    return (
        <Box>
            <MUIDrawer
                anchor='left'
                open={open}
                onClose={toggleDrawer(false)}
            >
                {list}
            </MUIDrawer>
        </Box>
    );
}

const DrawerListItem = ({ onClick, text, icon }) => {
    return (
        <ListItem disablePadding>
            <ListItemButton onClick={onClick}>
                <ListItemIcon>
                    {
                        React.cloneElement(
                            icon,
                            { 
                                fontSize: 'large',
                            }
                        )
                    }
                </ListItemIcon>
                <ListItemText primary={text} />
            </ListItemButton>
        </ListItem>
    );
}

export default withPather()(Drawer);